module.exports = (__webpack_require__(24))(20);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/moment/moment.js from dll-reference lib_core
// module id = 28
// module chunks = 107